// extracted by mini-css-extract-plugin
export default {"row":"Df6YDCidfE7hCboJqan5"};